var _path, _path2, _circle, _path3, _path4, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.2541 36.7089L75.2541 12.7089C74.8803 12.3382 74.437 12.0449 73.9497 11.8458C73.4623 11.6468 72.9405 11.5459 72.4141 11.5489H32.4141C31.3532 11.5489 30.3358 11.9703 29.5856 12.7205C28.8355 13.4706 28.4141 14.488 28.4141 15.5489V111.549C28.4141 112.61 28.8355 113.627 29.5856 114.377C30.3358 115.127 31.3532 115.549 32.4141 115.549H96.4141C97.4749 115.549 98.4923 115.127 99.2425 114.377C99.9926 113.627 100.414 112.61 100.414 111.549V39.5489C100.417 39.0225 100.316 38.5006 100.117 38.0133C99.9181 37.5259 99.6248 37.0827 99.2541 36.7089Z",
    fill: "#DDDDDD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2541 12.7089C74.8803 12.3382 74.437 12.0449 73.9497 11.8458C73.4623 11.6468 72.9405 11.5459 72.4141 11.5489V35.5489C72.4141 36.6098 72.8355 37.6272 73.5856 38.3773C74.3358 39.1275 75.3532 39.5489 76.4141 39.5489H100.414C100.417 39.0225 100.316 38.5006 100.117 38.0133C99.9181 37.5259 99.6248 37.0827 99.2541 36.7089L75.2541 12.7089Z",
    fill: "#AAAAAA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100.586,
    cy: 85.6539,
    r: 20.2105,
    fill: "#AAAAAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.25 78.3096L108.902 93.9616",
    stroke: "#EEEEEE",
    strokeWidth: 4.81203,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.898 78.3096L93.2464 93.9616",
    stroke: "#EEEEEE",
    strokeWidth: 4.81203,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44.7734,
    y: 55.8203,
    width: 38.4962,
    height: 3.84962,
    rx: 1.92481,
    fill: "#AAAAAA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7734,
    y: 68.3311,
    width: 32.7218,
    height: 3.84962,
    rx: 1.92481,
    fill: "#AAAAAA"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44.7734,
    y: 80.8418,
    width: 24.0602,
    height: 3.84962,
    rx: 1.92481,
    fill: "#AAAAAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyDoc);
export default __webpack_public_path__ + "static/media/empty-doc.f2c1c13b90a6da926729e5feeee3edf4.svg";
export { ForwardRef as ReactComponent };